import styled from "@emotion/styled"
import { breakpoint, spacingFluidLg, spacingFluidXl } from "@porsche-design-system/components-react/emotion"
import { shouldForwardProp } from "src/common/shouldForwardProp"
import { Flex, Grid, GridItem, mapGapToSpacingFluid, Skeleton } from "src/components"
import type { FlexProps } from "src/components"
import { useMediaQueryWidth } from "src/hooks"
import { OverviewSummaryImagesSkeleton } from "../overviewSummaryImages/OverviewSummaryImagesSkeleton"

export const OverviewSummarySkeleton = () => {
	const isSmall = useMediaQueryWidth({ max: "l" })
	const columnGap = isSmall ? spacingFluidLg : spacingFluidXl
	const rowGap: FlexProps["$gap"] = "md"

	return (
		<Grid $columnGap={columnGap} $rowGap={mapGapToSpacingFluid[rowGap]}>
			<GridItem size={{ base: 12, l: 4, m: 6 }}>
				<OverviewSummaryImagesSkeleton />
			</GridItem>
			<GridItem size={{ base: 12, l: 4, m: 6 }}>
				<Flex $gap={rowGap} $direction="column">
					<Skeleton.List entries={5} withHeader />
					<Skeleton.List entries={5} withHeader />
				</Flex>
			</GridItem>
			<GridItem size={{ base: 12, l: 4, m: 12 }}>
				<InnerGrid $columnGap={columnGap} $rowGap={mapGapToSpacingFluid[rowGap]}>
					<Skeleton.List entries={5} withHeader />
					<Skeleton.List entries={5} withHeader />
				</InnerGrid>
			</GridItem>
		</Grid>
	)
}

const InnerGrid = styled("div", { shouldForwardProp })<{ $columnGap: string; $rowGap: string }>`
	display: grid;
	gap: ${({ $rowGap }) => $rowGap};
	column-gap: ${({ $columnGap }) => $columnGap};

	@media (min-width: ${breakpoint.m}px) and  (max-width: ${breakpoint.l}px) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
`
